//
//
//
//

export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            checked: 'false'
        }
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(n) {
                this.$emit('input', n);
            }
        },
        isChecked: function() {
            return this.checked === 'true'
        }
    },
    watch: {
        model: {
            handler(n) {
                if(!this.isChecked) return;

                setLocal('userLogin', n);
            }, deep: true
        }
    },
    methods: {
        changeHandler(e) {
            setLocal('autoPsw', e);

            if(!this.isChecked) {
                setLocal('userLogin', '{}');
            } else {
                setLocal('userLogin', this.model);
            }
        },
        getAutoPsw() {
            this.checked = getLocal('autoPsw');

            if(this.isChecked) {
                var userLogin = getLocal('userLogin');

                this.model = userLogin === 'undefined' ? {} : userLogin;
            }
        }
    },
    mounted: function() {
        this.getAutoPsw();
    }
}
